import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import { HttpStatusCodes } from '../../util/uiconstants';
import Utility from '../../util/utilityfunctions';
import _ from 'lodash';

export default function journalSourceReducer(state = initialstate.journalSource, action) {
	switch (action.type) {
		case types.GET_JOURNAL_SOURCE: {
			return Utility.normalize(action.response);
		}
		case types.UPDATE_JOURNAL_SOURCE: {
			const { response, responseObj } = action;

			if (responseObj.status === HttpStatusCodes.Ok) {
				let clonedState = _.cloneDeep(state);
				Object.keys(response).forEach((key) => {
					clonedState.byId[response.journalSourceId][key] = response[key];
				});
				return clonedState;
			}
			return state;
		}
		case types.UPDATE_JOURNAL_SOURCE_RELATED_SCOT: {
			const { response, responseObj } = action;

			if (responseObj.status === HttpStatusCodes.Ok) {
				let clonedState = _.cloneDeep(state);
				clonedState.byId[response.journalSourceId].hasRelatedSCOT = response.hasRelatedSCOT;

				return clonedState;
			}

			return state;
		}
		case types.UPDATE_JOURNAL_SOURCE_CUSTOM_NAME: {
			const { response, responseObj } = action;

			if (responseObj.status === HttpStatusCodes.Ok) {
				let clonedState = _.cloneDeep(state);
				clonedState.byId[response.journalSourceId].customName = response.customName;

				return clonedState;
			}

			return state;
		}
		case types.POST_SCOT_JOURNAL_SOURCE: {
			const { response, responseObj } = action;

			if (responseObj.status === HttpStatusCodes.Ok) {
				let clonedState = _.cloneDeep(state);
				clonedState.byId[response.journalSourceId].scotJournalSource.push(response);

				return clonedState;
			}
			return state
		}
		case types.DELETE_SCOT_JOURNAL_SOURCE: {
			const { responseObj, SCOTJournalSource } = action;

			if (responseObj.status === HttpStatusCodes.Ok) {
				let clonedState = _.cloneDeep(state);
				const filteredScotJEs = clonedState.byId[SCOTJournalSource.journalSourceId].scotJournalSource
					.filter((scotJE) => scotJE.id !== SCOTJournalSource.id);

				clonedState.byId[SCOTJournalSource.journalSourceId].scotJournalSource = [...filteredScotJEs]
				return clonedState;
			}
			return state;
		}
		default:
			return state;
	}
}
